import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import analytics from '../../shared/services/analytics/analytics';
import {
  changeChartType,
  cleanRecordSet,
  cleanRecordSetChart,
  getRecordsSet,
  updateActiveButtonChart,
  updateHideButtonChart,
} from '../../actions/AlphasActions';
import {
  changeTypeOfChart,
  getRecordsSetSimulation,
  updateActiveButtonChartSimulation,
  updateHideButtonChartSimulation,
} from '../../actions/Simulation/DataAction';
import { StateType } from '../../reducers';
import { activeTabSelector } from '../../reducers/EditorReducer/EditorSelector';
import { convertArrayFromDropdownRecordSet } from '../../shared/helpers';
import { DispatchConnect, ImmutableInterface } from '../../types';
import HOCIsMobile from '../HOCIsMobile/HOCIsMobile';

import { ChartContainerProps, ChartContainerState, ChartGenericType, ChartStateDispatchers, ChartStateProps } from './types';
import { getOffset, Chart } from './Chart';
import { ChartData } from './HOCAlphaChart';

export class ChartContainer extends React.Component<ChartGenericType, ChartContainerState> {
  state = {
    currentAlphaRequested: '',
    currentRecordOption: '',
    extremes: {},
    zoomOutButtonSize: this.props.isMobile ? 5 : 20,
  };

  private observer: any;
  private observerRight: any;
  private observerLeft: any;

  componentDidMount() {
    const alphaId = this.props.alpha && this.props.alpha.get('id');
    if (!this.props.isSimulation && this.props.alpha) {
      this.getRecordSet(alphaId, this.props.recordSetsOption);
    }
    if (this.props.pathNoneAllButtons) {
      this.props.dispatchUpdateActiveButtonChart(true);
    }
    setTimeout(this.changeZoomOutBottomPosition, 500);
  }

  componentDidUpdate(prevProps: ChartGenericType) {
    const navigatorSize: any = document.querySelector(`#${this.props.id} .highcharts-navigator-mask-inside`);
    const navigatorRight: any = document.querySelector(`#${this.props.id} .highcharts-navigator-handle-right`);
    const navigatorLeft: any = document.querySelector(`#${this.props.id} .highcharts-navigator-handle-left`);
    const svg: any = document.querySelector(`#${this.props.id} .highcharts-root`);
    const alphaDetailBox: any = document.querySelector(`#${this.props.id}`);
    if (navigatorSize && navigatorRight && navigatorLeft) {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
        this.observerRight.disconnect();
        this.observerRight = null;
        this.observerLeft.disconnect();
        this.observerLeft = null;
      }
      const config = { attributes: true, childList: true, subtree: true };
      this.observer = new MutationObserver(this.callbackMutateObserver);
      this.observer.observe(navigatorSize, config);
      this.observerRight = new MutationObserver(this.callbackMutateObserverRight);
      this.observerRight.observe(navigatorSize, config);
      this.observerLeft = new MutationObserver(this.callbackMutateObserverLeft);
      this.observerLeft.observe(navigatorSize, config);
    }

    if (this.props.shouldNotSetZoomButton !== true) {
      const zoomButton: any = document.querySelector(`#${this.props.id} .chart__zoom-out`);
      if (zoomButton) {
        zoomButton.style.bottom = `${this.changeZoomOutPosition()}px`;
        if (document.querySelector('.simulation') && svg && alphaDetailBox) {
          const paddingOutsideMobile = this.props.isMobile ? 0 : 20;
          zoomButton.style.left = `${
            svg.getBoundingClientRect().right - alphaDetailBox.getBoundingClientRect().left - paddingOutsideMobile
          }px`;
        }
      }
    }
    if (this.props.isMobile !== prevProps.isMobile) {
      this.setState({ zoomOutButtonSize: this.props.isMobile ? 5 : 20 });
    }
  }

  componentWillUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps: any) {
    const activeTab = nextProps.activeTab;
    const childrenIndex = activeTab && activeTab.get('activeChildTab');
    const childrenId =
      activeTab && activeTab.get('activeChildTab') !== undefined ? activeTab.getIn(['childTabs', childrenIndex, 'id']) : null;

    if (!this.props.isSimulation && this.props.alpha && this.props.alpha.get('id') !== nextProps.alpha.get('id')) {
      this.getRecordWhenChangingAlphas(nextProps.alpha);
    }
    if (
      this.props.isSimulation &&
      this.props.recordSetsOption !== nextProps.recordSetsOption &&
      activeTab &&
      this.props.activeTab.get('id') === activeTab.get('id') &&
      nextProps.alpha &&
      this.props.alpha.get('id') === nextProps.alpha.get('id')
    ) {
      this.getRecordSet(nextProps.alpha.get('id'), nextProps.recordSetsOption, activeTab.get('id'), childrenId);
    }
    if (
      !this.props.isSimulation &&
      this.props.recordSetsOption !== nextProps.recordSetsOption &&
      nextProps.alpha &&
      this.props.alpha.get('id') === nextProps.alpha.get('id')
    ) {
      this.getRecordSet(nextProps.alpha.get('id'), nextProps.recordSetsOption);
    }
  }

  getRecordSet = (alphaId: string, recordOption: string, idParent?: string, idChild?: any) => {
    if (this.state.currentAlphaRequested === alphaId && this.state.currentRecordOption === recordOption) {
      return;
    }
    this.setState({ currentAlphaRequested: alphaId, currentRecordOption: recordOption });
    if (this.props.isSimulation && idParent) {
      this.props.dispatchGetRecordsSetSimulation(alphaId, idParent, idChild);
    } else {
      this.props.dispatchGetRecordsSet(alphaId);
    }
  };

  handleSetExtremes = (extremes: any) => {
    if (extremes.userMax !== undefined) {
      this.setState({ extremes: extremes });

      if (this.props.setExtremesCallback) {
        this.props.setExtremesCallback(extremes);
      }
    }
  };

  changeZoomOutBottomPosition = () => {
    const zoomButton: any = document.querySelector(`#${this.props.id} .chart__zoom-out`);
    if (zoomButton) {
      zoomButton.style.bottom = `${this.changeZoomOutPosition()}px`;
    }
  };

  getRecordWhenChangingAlphas = (alpha: any) => {
    this.props.dispatchCleanRecordSet();
    this.props.dispatchCleanRecordSetChart();
    this.getRecordSet(alpha.get('id'), 'pnl');
  };

  changeZoomOutPosition = () => {
    const defaultHeight = 21;
    const zoomOutButton = document.querySelector(`#${this.props.id} .footer-menu__filters-buttons`);
    const highchart = document.getElementById(`${this.props.id}`);
    const barUnderScrollBar = document.querySelector(`#${this.props.id} .highcharts-navigator-handle-right`);
    if (zoomOutButton && barUnderScrollBar) {
      const topButton = getOffset(zoomOutButton);
      const topNavigator = getOffset(barUnderScrollBar);
      // 4 represents the difference between the filter buttons and the zoomOutButton

      return topButton - topNavigator + 4;
    } else if (highchart && barUnderScrollBar) {
      const chartMeasures = highchart.getBoundingClientRect();
      const scrollBarMeasures = barUnderScrollBar.getBoundingClientRect();
      const styledComponent = window.getComputedStyle(highchart);
      const paddingBottom = parseFloat(styledComponent.getPropertyValue('padding-bottom'));

      return chartMeasures.bottom - scrollBarMeasures.bottom - paddingBottom - 1;
    }

    return defaultHeight;
  };

  callbackMutateObserver = (mutationsList: any) => {
    mutationsList.map((mutation: any) => {
      const navigatorSize: any = document.querySelector(`#${this.props.id} .highcharts-navigator-mask-inside`);
      if (navigatorSize && mutation.attributeName === 'height' && mutation.target.getAttribute('height') === '21') {
        navigatorSize.setAttribute('height', '12');
      }
    });
  };

  callbackMutateObserverRight = (mutationsList: any) => {
    mutationsList.map((mutation: any) => {
      if (mutation.attributeName === 'y' && mutation.target.getAttribute('y') !== '1') {
        const navigatorHandleRight: any = document.querySelector(`#${this.props.id} .highcharts-navigator-handle-right`);
        navigatorHandleRight.setAttribute('y', '1');
        if (this.props.shouldNotSetZoomButton !== true) {
          this.changeZoomOutBottomPosition();
        }
      }
    });
  };

  callbackMutateObserverLeft = (mutationsList: any) => {
    mutationsList.map((mutation: any) => {
      if (mutation.attributeName === 'y' && mutation.target.getAttribute('y') !== '1') {
        const navigatorHandleLeft: any = document.querySelector(`#${this.props.id} .highcharts-navigator-handle-left`);
        navigatorHandleLeft.setAttribute('y', '1');
      }
    });
  };

  handleChangeRecordSets = (_: any, data: any) => {
    if (this.props.isSimulation) {
      const tabId = this.props.activeTab.get('id');
      const childrenIndex = this.props.activeTab && this.props.activeTab.get('activeChildTab');
      const childrenId =
        this.props.activeTab && this.props.activeTab.get('activeChildTab') !== undefined
          ? this.props.activeTab.getIn(['childTabs', childrenIndex, 'id'])
          : null;
      if (data.value !== this.props.recordSetsOption) {
        analytics.trackCustomEvent('sim_switch_chart', { event_label: data.value });
        this.props.dispatchChangeChart(tabId, childrenId, data.value);
      }
    } else {
      if (data.value !== this.props.recordSetsOption) {
        this.props.dispatchChangeChartType(data.value);
      }
    }
  };

  handleAllButton = (status: boolean) => {
    if (this.props.isSimulation) {
      const childrenIndex = this.props.activeTab && this.props.activeTab.get('activeChildTab');
      const childrenId =
        this.props.activeTab && this.props.activeTab.get('activeChildTab') !== undefined
          ? this.props.activeTab.getIn(['childTabs', childrenIndex, 'id'])
          : null;
      const tabId = this.props.activeTab.get('id');
      this.props.dispatchUpdateActiveButtonChartSimulation(tabId, childrenId, status);
    } else {
      this.props.dispatchUpdateActiveButtonChart(status);
    }
  };

  handleHideButton = (status: boolean) => {
    if (this.props.isSimulation) {
      const childrenIndex = this.props.activeTab && this.props.activeTab.get('activeChildTab');
      const childrenId =
        this.props.activeTab && this.props.activeTab.get('activeChildTab') !== undefined
          ? this.props.activeTab.getIn(['childTabs', childrenIndex, 'id'])
          : null;
      const tabId = this.props.activeTab.get('id');
      this.props.dispatchUpdateHideButtonChartSimulation(tabId, childrenId, status);
    } else {
      this.props.dispatchUpdateHideButtonChart(status);
    }
  };

  // Filter the chart data so the chart only display the data relate with alphas
  // ID that are in the props.filterChartData
  filterData(chartData: ImmutableInterface<ChartData>) {
    const { filterChartData } = this.props;
    const filterData: any = filterChartData;
    const records = chartData.get('records').filter((record: any) => filterData.includes(record.get('id')));

    const properties = (chartData.getIn(['schema', 'properties']) as ChartData['schema']['properties']).filter((property: any) => {
      if (property.get('name') === 'date' || filterData.includes(property.get('name'))) {
        return property;
      }
    });

    return chartData.setIn(['schema', 'properties'], properties).set('records', records);
  }

  render() {
    const {
      modifiers,
      recordSets,
      recordSetsOption,
      chartData,
      isFetchingChartData,
      isFetchingRecordSets,
      showCode,
      showLearn,
      shouldResize,
      id = 'alphas-chart',
      valueType = 'decimal',
      currency = null,
      alpha,
      path,
      fatherClass,
      position,
      pathNoneAllButtons,
      filterChartData,
      showAllAndNoneButtons,
      noResults,
      addId,
      isTestPeriodControlShown,
      isTestPeriodShown,
      onChangeTestPeriodShown,
      customNavigatorSize,
    } = this.props;

    const alphaHasVisualization = alpha && alpha.getIn(['settings', 'visualization']);
    const recordSetsChart = recordSets ? convertArrayFromDropdownRecordSet(recordSets.get('results').toJS(), alphaHasVisualization) : null;

    const isFetchingRecordSetChart = isFetchingRecordSets || isFetchingChartData;
    const data = Array.isArray(filterChartData) && chartData ? this.filterData(chartData) : chartData;

    return (
      <Chart
        valueType={valueType}
        modifiers={modifiers}
        recordSets={recordSetsChart}
        recordSetsOption={recordSetsOption}
        handleChangeRecordSets={this.handleChangeRecordSets}
        chartData={data}
        isFetchingRecordSetChart={isFetchingRecordSetChart}
        showCode={showCode}
        showLearn={showLearn}
        shouldResize={shouldResize}
        id={id}
        alpha={alpha}
        handleAllButton={this.handleAllButton}
        handleHideButton={this.handleHideButton}
        path={path}
        fatherClass={fatherClass}
        extremes={this.state.extremes}
        handleSetExtremes={this.handleSetExtremes}
        getChartRef={this.props.getChartRef}
        currency={currency}
        position={position}
        pathNoneAllButtons={pathNoneAllButtons}
        showAllAndNoneButtons={showAllAndNoneButtons}
        noResults={noResults}
        addId={addId}
        isTestPeriodControlShown={isTestPeriodControlShown}
        isTestPeriodShown={isTestPeriodShown}
        onChangeTestPeriodShown={onChangeTestPeriodShown}
        customNavigatorSize={customNavigatorSize}
      />
    );
  }
}

function mapStateToProps(state: StateType, props: ChartContainerProps): ChartStateProps {
  const alphaPath = props.path.concat(['alphaDetail']);
  const recordSetsOption = props.path.concat(['chartType']);

  const recordSetsPath = props.path.concat(['recordsSets']);
  const isFetchingRecordSetsPath = props.path.concat(['fetchingRecordSets']);

  // Chart data can be retrieved in two ways:
  // 1. From own props (chartData and isFetchingChartData)
  // 2. From Redux store:
  //    - chartData: [...props.path, 'chartData']
  //    - isFetchingChartData: [...props.path, 'fetchingRecordSetsChart']
  let chartData, isFetchingChartData;
  if (typeof props.isFetchingChartData !== 'undefined' && typeof props.chartData !== 'undefined') {
    chartData = props.chartData;
    isFetchingChartData = props.isFetchingChartData;
  } else {
    chartData = state.getIn(props.path.concat(['chartData']));
    isFetchingChartData = state.getIn(props.path.concat(['fetchingRecordSetsChart'])) as boolean;
  }

  return {
    activeTab: activeTabSelector(state),
    alpha: state.getIn(alphaPath),
    recordSetsOption: state.getIn(recordSetsOption) as string,

    recordSets: state.getIn(recordSetsPath),
    isFetchingRecordSets: state.getIn(isFetchingRecordSetsPath) as boolean,

    chartData,
    isFetchingChartData,
  };
}

const mapDispatchToProps = (dispatch: Dispatch<any>): ChartStateDispatchers => ({
  dispatchGetRecordsSetSimulation: async (alphaId: string, idParent: string, idChild: string | null) =>
    dispatch(getRecordsSetSimulation(alphaId, idParent, idChild)),
  dispatchGetRecordsSet: async (alphaId: string) => dispatch(getRecordsSet(alphaId)),
  dispatchChangeChartType: (chartType: string) => dispatch(changeChartType(chartType)),
  dispatchChangeChart: (idParent: string, idChild: string | null, chartType: string) => {
    dispatch(changeTypeOfChart(idParent, idChild, chartType));
  },
  dispatchUpdateActiveButtonChartSimulation: (idParent: string, idChild: string | null, data: boolean) => {
    dispatch(updateActiveButtonChartSimulation(idParent, idChild, data));
  },
  dispatchUpdateHideButtonChartSimulation: (idParent: string, idChild: string | null, data: boolean) => {
    dispatch(updateHideButtonChartSimulation(idParent, idChild, data));
  },
  dispatchUpdateActiveButtonChart: (data: boolean) => {
    dispatch(updateActiveButtonChart(data));
  },
  dispatchUpdateHideButtonChart: (data: boolean) => {
    dispatch(updateHideButtonChart(data));
  },
  dispatchCleanRecordSet: () => dispatch(cleanRecordSet()),
  dispatchCleanRecordSetChart: () => dispatch(cleanRecordSetChart()),
});

export default connect<ChartStateProps, DispatchConnect<ChartStateDispatchers>, any, StateType>(
  mapStateToProps,
  mapDispatchToProps
)(HOCIsMobile(ChartContainer));
